// extracted by mini-css-extract-plugin
export var barWrapper = "ProgressBar_barWrapper__iXyDx";
export var pages = "ProgressBar_pages__n2PZN";
export var progressBar = "ProgressBar_progressBar__q3C4T";
export var progressBarCompletion = "ProgressBar_progressBarCompletion__8X0sw";
export var progressBarContainer = "ProgressBar_progressBarContainer__tmSK1";
export var slidein = "ProgressBar_slidein__OBgsg";